import styled from "styled-components";

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;

  label {
    font-style: normal;
    font-weight: normal;
    font-size: 0.9rem;
    color: var(--grey-100);
    font-family: DM Sans;
  }

  hr {
    margin: 1.5rem 0rem;
    height: 1px;
    background-color: rgba(82, 82, 82, 0.64);
    border: none;
  }
`;

export const Form = styled.form`
  display: grid;
  grid-template-columns: 1fr 1fr;
  height: 100%;

  input {
    width: 22.5rem;
  }

  textarea {
    width: 100%;
    height: 96px;
    background: var(--black-100);
    border-radius: 4px;
    margin-top: 12px;
    padding: 1rem;
    font-family: Inter;
  }

  p {
    color: var(--white);
  }

  select {
    width: 22.5rem;
  }
`;

export const FormColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 1.5rem;

  h3 {
    margin-bottom: 1.5rem;
  }

  &:first-of-type {
    border-right: 1px solid #3d3d3d;

    input {
      width: 100%;
    }
  }

  &:last-of-type {
    overflow-y: auto;
  }

  .infoInput {
    margin-bottom: 1rem;
  }

  > div {
    width: 100%;

    > div,
    > div > input {
      width: 100% !important;
      margin-top: 1rem;
    }
  }
`;

export const RegionContainer = styled.div`
  display: flex;
  flex-direction: column;

  > button {
    background: var(--white);
    font-family: Inter;
    font-weight: bold;
    font-size: 0.85rem;
    padding: 0.6rem;
    border-radius: 5px;

    &:disabled {
      background: var(--grey-200);
      color: var(--grey-300);
      cursor: default;
    }
  }
`;

export const ValueForm = styled.form`
  > button {
    display: none;
  }

  input {
    width: 100%;
  }
`;

export const RegionInputContainer = styled.div``;

export const ValuesContainer = styled.div`
  margin-top: 1.5rem;
  margin-bottom: 2rem;

  > header > h4 {
    margin: 1rem 0rem;
  }
`;

export const FormGroup = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 1rem;
`;

export const RegionList = styled.div`
  > div {
    width: 100%;
  }
`;
